import React from 'react';
import { Filter as FilterAdmin, TextInput, SelectInput } from 'react-admin';

import {
  CnpjInput,
  CpfInput,
  PeriodoInput,
  PrecoInput,
} from '../../Components/InputsReactAdmin';
import {
  STATUS_EMISSAO_NFE_PENDENTE,
  STATUS_EMISSAO_NFE_AUTORIZADA,
  STATUS_EMISSAO_NFE_AUTORIZADA_SEM_XML,
  STATUS_EMISSAO_NFE_CANCELADA,
  STATUS_EMISSAO_NFE_CONTINGENCIA,
  STATUS_EMISSAO_NFE_CONTINGENCIA_ENVIADA,
  STATUS_EMISSAO_NFE_DENEGADA,
  STATUS_EMISSAO_NFE_INDEFINIDA,
  STATUS_EMISSAO_NFE_PROCESSANDO,
  STATUS_EMISSAO_NFE_REJEITADA,
  STATUS_EMISSAO_NFE_REJEITADA_DEFINITIVO,
  STATUS_EMISSAO_NFE_DESCONHECIDO,
  STATUS_EMISSAO_NFE_REJEITADA_REPROCESSAMENTO,
} from '../../utils/constants';

const choices = [
  { id: STATUS_EMISSAO_NFE_PENDENTE, name: 'Pendente' },
  { id: STATUS_EMISSAO_NFE_PROCESSANDO, name: 'Processando' },
  { id: STATUS_EMISSAO_NFE_AUTORIZADA, name: 'Autorizada' },
  { id: STATUS_EMISSAO_NFE_AUTORIZADA_SEM_XML, name: 'Autorizada sem XML' },
  { id: STATUS_EMISSAO_NFE_CONTINGENCIA, name: 'Contingência' },
  {
    id: STATUS_EMISSAO_NFE_CONTINGENCIA_ENVIADA,
    name: 'Contingência enviada',
  },
  { id: STATUS_EMISSAO_NFE_CANCELADA, name: 'Cancelada' },
  { id: STATUS_EMISSAO_NFE_DENEGADA, name: 'Denegada' },
  { id: STATUS_EMISSAO_NFE_REJEITADA, name: 'Rejeitada' },
  { id: STATUS_EMISSAO_NFE_INDEFINIDA, name: 'Indefinida' },
  {
    id: STATUS_EMISSAO_NFE_REJEITADA_DEFINITIVO,
    name: 'Rejeitada Definitivo',
  },
  {
    id: STATUS_EMISSAO_NFE_DESCONHECIDO,
    name: 'Desconhecido',
  },
  {
    id: STATUS_EMISSAO_NFE_REJEITADA_REPROCESSAMENTO,
    name: 'Rejeitada Reprocessamento',
  },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <PeriodoInput
      source="periodo"
      label="Peŕiodo"
      defaultValue={{
        start: new Date(),
        end: new Date(),
      }}
    />
    <SelectInput
      source="status_emissao_nfce"
      choices={choices}
      label="Status da Emissão"
      allowEmpty={false}
    />
    <TextInput label="Nome" source="nome" />
    <TextInput label="Razão Social" source="razao_social" />
    <TextInput label="Nome Fantasia" source="nome_fantasia" />
    <CnpjInput label="CNPJ" source="cnpj" />
    <CpfInput label="CPF" source="cpf" />
    <TextInput source="numero" label="Número da venda" />
    <TextInput source="erro_sefaz" label="Erro" />
    <PrecoInput
      source="valor"
      label="Valor da venda"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorDinheiro"
      label="Valor Parcela Dinheiro"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorPix"
      label="Valor Parcela Pix"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorDebito"
      label="Valor Parcela Débito"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorVonchuer"
      label="Valor Parcela Voucher"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorDescontoDevolucao"
      label="Valor Parcela Devolução"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorCredito"
      label="Valor Parcela Crédito"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorBoleto"
      label="Valor Parcela Boleto"
      fixedDecimalScale={false}
    />
  </FilterAdmin>
);

export default Filter;
